<div class="flex align-items-center">
	<p-selectButton [options]="periods" [(ngModel)]="period" (onChange)="refresh()"></p-selectButton>
	<ng-container *ngIf="showDates">
		Du <p-calendar [yearNavigator]="true" yearRange="2019:2022" [firstDayOfWeek]="1"  inputStyleClass="p-inputtext-sm" [(ngModel)]="range[0]" [readonlyInput]="true" dateFormat="dd/mm/yy"></p-calendar>
		au
		<p-calendar [yearNavigator]="true" yearRange="2019:2022" [firstDayOfWeek]="1"  inputStyleClass="p-inputtext-sm" (onSelect)="chooseDates()" [(ngModel)]="range[1]" [readonlyInput]="true" dateFormat="dd/mm/yy"></p-calendar>
		<p-button styleClass="p-button-lg p-button-text" icon="pi pi-refresh" (click)="refresh()"></p-button>
	</ng-container>
</div>
